<AvatarCell src={item.pictureUrl} text={item.displayName} />
<Cell type="participant-name">
    <span class="participant-name__display-name" slot="header-data">{item.displayName}</span>
    <span class="participant-name__username" slot="data">{item.userName}</span>
</Cell>

<script>
    import AvatarCell from "@itslearning/prometheus/assets/lists/AvatarCell/v1/AvatarCell.svelte";
    import Cell from "@itslearning/prometheus/assets/lists/Cell/v1/Cell.svelte";

    export let item;
</script>
